<template>
  <!--品牌专场页面-->
  <tk-container
    :status="status"
    :probeType="3"
    infiniteScroll
    hide-status-bar
    @refresh="refreshInit"
    @scroll="watchScroll"
    :style="{background: bgColor}"
    ref="resetBrandSpecial"
    @loadingMore="recommendedProducts"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="true"
                     :is-header-color="isHeaderColor" :back-style="isHeaderColor ? false : true" :icon-name="'return'"></gradient-header>
    <!--背景图渲染-->
    <div class="brand-special-bg" :style="`background-image: url(${bgSrc}) !important`"></div>
    <!--品牌一数据渲染-->
    <div class="p-x-12 m-t-15">
      <linear-card
        :width="100" :height="200"
        :linear-bottom-color="'#fff'"
        :linear-top-color="'#CDFFFC'"
        :commodity-arr="oneBrandCommodity"
        :type="'oneBrandSpecial'"
        :title="brandSpecial.length && brandSpecial[0].name ? brandSpecial[0].name : ''"
        :is-more="true"
      >
        <tk-flex class="p-b-8" wrap v-if="oneBrandCommodity.length">
          <lookCommodity
            class="p-x-12 p-t-8"
            v-for="(s, index) in oneBrandCommodity"
            :key="index"
            :commodity="s"
            :selling-color="'#999'"
            :selling-bg="'rgba(255, 255, 255, 0)'"
          >
          </lookCommodity>
        </tk-flex>
        <empty-tips v-else :height="200" :width="100" :empty-msg="'暂无数据'"></empty-tips>
      </linear-card>
    </div>
    <!--品牌二数据渲染-->
    <div class="p-x-12 m-t-15">
      <linear-card
        :width="100" :height="50"
        :linear-bottom-color="'#fff'"
        :linear-top-color="'#FFCDFB'"
        :commodity-arr="twoBrandCommodity"
        :type="'twoBrandSpecial'"
        :title="brandSpecial.length && brandSpecial[1].name ? brandSpecial[1].name : ''"
        :is-more="true"
      >
        <tk-flex wrap class="p-x-12 p-b-8" v-if="twoBrandCommodity.length">
          <commodity-three-row
            class="p-t-8"
            v-for="(s, index) in twoBrandCommodity"
            :key="index"
            :commodity="s"
            :selling-color="'#999'"
            :selling-bg="'rgba(255, 255, 255, 0)'"
          >
          </commodity-three-row>
        </tk-flex>
        <empty-tips v-else :height="200" :width="100" :empty-msg="'暂无数据'"></empty-tips>
      </linear-card>
    </div>
    <!--品牌三数据渲染-->
    <div class="p-x-12 m-t-15">
      <linear-card
        :width="100" :height="50"
        :linear-bottom-color="'#fff'"
        :linear-top-color="'#FFDD8A'"
        :commodity-arr="threeBrandCommodity"
        :type="'threeBrandSpecial'"
        :title="brandSpecial.length && brandSpecial[2].name ? brandSpecial[2].name : ''"
        :is-more="true"
      >
        <tk-flex wrap class="p-x-12 p-b-8" v-if="threeBrandCommodity.length">
          <commodity-three-row
            v-for="(s, index) in threeBrandCommodity"
            :key="index"
            class="p-t-8"
            :commodity="s"
            :selling-color="'#999'"
            :selling-bg="'rgba(255, 255, 255, 0)'"
          >
          </commodity-three-row>
        </tk-flex>
        <empty-tips v-else :height="200" :width="100" :empty-msg="'暂无数据'"></empty-tips>
      </linear-card>
    </div>
    <!--品牌四数据渲染-->
    <div class="p-x-12 m-t-15">
      <linear-card
        :width="100" :height="50"
        :linear-bottom-color="'#fff'"
        :linear-top-color="'#FFB3B3'"
        :commodity-arr="fourBrandCommodity"
        :type="'fourBrandSpecial'"
        :title="brandSpecial.length && brandSpecial[3].name ? brandSpecial[3].name : ''"
        :is-more="true"
      >
        <tk-flex wrap class="p-x-12 p-b-8" v-if="fourBrandCommodity.length">
          <commodity-three-row
            v-for="(s, index) in fourBrandCommodity"
            :key="index"
            class="p-t-8"
            :commodity="s"
            :selling-color="'#999'"
            :selling-bg="'rgba(255, 255, 255, 0)'"
          >
          </commodity-three-row>
        </tk-flex>
        <empty-tips v-else :height="200" :width="100" :empty-msg="'暂无数据'"></empty-tips>
      </linear-card>
    </div>
    <!--为你推荐数据-->
    <infinite-list :title="'为你推荐'" :infinite-list-pad="'p-x-12'" :products-data="getPriceProcessing(recommendedProductsData, judgeTimeRule)" :color="'#fff'"></infinite-list>
  </tk-container>
</template>

<script>
import linearCard from '@/components/linearCard'
import lookCommodity from '@/components/lookCommodity'
import commodityThreeRow from '@/components/commodityThreeRow'
import { priceProcessing } from '@/assets/help/tool'
export default {
  components: {
    linearCard,
    lookCommodity,
    commodityThreeRow
  },
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      isHeaderColor: false, // 判断头部颜色切换
      themeBackground: null, // 主题背景图片
      brandSpecial: [], // 品牌专场数据
      oneBrandCommodity: [], // 品牌一商品数据
      twoBrandCommodity: [], // 品牌二商品数据
      threeBrandCommodity: [], // 品牌三商品数据
      fourBrandCommodity: [], // 品牌四商品数据
      timeRule: {}, // 限时抢购时间规则
      recommendedProductsData: [] // 为你推荐商品数据获取
    }
  },
  computed: {
    // 背景图src
    bgSrc () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.image)) { return '' }
      return this.themeBackground.image
    },
    // 背景颜色
    bgColor () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.bgColor)) { return '' }
      return this.themeBackground.bgColor
    },
    // 判断抢购时间是否有效
    judgeTimeRule () {
      if (!this.timeRule) return false
      let endSum = new Date(this.timeRule.endTime).getTime()
      let nowSum = new Date().getTime()
      return nowSum - endSum < 0
    }
  },
  activated () {
    this.setStatusBar('light')
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
     * 页面初始化
     * @date: 2020/4/8
     */
    async getInit () {
      try {
        await this.getThemeBackground() // 获取主题图片
        await this.getLimitedTimeRule() // 获取限时抢购的时间 （只获取1条）
        await this.getBrandSpecial() // 获取品牌专场类别 （按创建时间最新的4条）
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.recommendedProductsData = []
      await this.getInit()
      this.$refs.resetBrandSpecial.resetInfiniteScroll()
    },
    /**
     * 限时抢购时间获取
     * @date: 2020/3/20
     */
    async getLimitedTimeRule () {
      let isoStartDate = new Date().toISOString()
      let startTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/startTime').catch(e => {
        return { data: null }
      })
      let endTime = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/endTime').catch(e => {
        return { data: null }
      })
      // 判断时间是否存在
      if (!startTime.data || !endTime.data) {
        this.timeRule = null
        return
      }
      let startSum = new Date(startTime.data).getTime()
      let nowSum = new Date(isoStartDate).getTime()
      if (nowSum <= startSum) {
        this.timeRule = null
        return
      }
      this.timeRule = {
        startTime: startTime.data,
        endTime: endTime.data
      }
    },
    /**
     * 获取主题图片
     * @date: 2020/4/8
     */
    async getThemeBackground () {
      let themeBackground = await this.$tkParse.getList('/classes/themeBackground', {
        params: {
          limit: 1,
          order: '-createdAt',
          where: {
            position: 'brandSpecial'
          }
        }
      })
      if (themeBackground.length) { this.themeBackground = themeBackground[0] } else {
        this.themeBackground = null
      }
    },
    /**
     * 品牌专场类别数据获取
     * @date: 2020/3/20
     */
    async getBrandSpecial () {
      let brandSpecial = await this.$tkParse.getList(`/classes/brandSpecial`, {
        params: {
          limit: 4,
          include: ['category'],
          order: '-createdAt'
        }
      })
      if (brandSpecial.length) {
        this.brandSpecial = brandSpecial.map(s => { return s.category })
        this.oneBrandCommodity = priceProcessing(await this.getBrandCommodity(3, brandSpecial[0].category.objectId), this.judgeTimeRule)
        this.twoBrandCommodity = priceProcessing(await this.getBrandCommodity(3, brandSpecial[1].category.objectId), this.judgeTimeRule)
        this.threeBrandCommodity = priceProcessing(await this.getBrandCommodity(6, brandSpecial[2].category.objectId), this.judgeTimeRule)
        this.fourBrandCommodity = priceProcessing(await this.getBrandCommodity(6, brandSpecial[3].category.objectId), this.judgeTimeRule)
      } else {
        this.brandSpecial = []
      }
    },
    /**
    * 根据类别获取品牌专场的数据
    * @prams 个数{count} 类别id{id}
    * @date: 2020/4/9
    */
    async getBrandCommodity (count, id) {
      // eslint-disable-next-line no-return-await
      return await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: count,
          // order: '-createdAt',
          order: 'weight',
          where: {
            shelvesStatus: 'shelves',
            category: id
          }
        }
      })
    },
    /**
     * 为你推荐数据获取
     * @date: 2020/3/24
     */
    async recommendedProducts (page, next) {
      let commodityData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves'
          }
        }
      })
      this.recommendedProductsData = [...this.recommendedProductsData, ...commodityData]
      if (commodityData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    }
  }
}
</script>

<style scoped lang="scss">
  /*背景图样式*/
  .brand-special-bg {
    width: 100%;
    height: 190px;
    padding-top: 70px;
    background-repeat:  no-repeat;
    background-size: 100% auto;
  }
  ::v-deep .before-trigger {
    color: #fff !important;
  }
</style>
